import * as React from "react";
const SvgTicket = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#000", d: "M0 16h22v-5c-1.7 0-3-1.3-3-3s1.4-3 3-3V0H0v5c1.7 0 3 1.3 3 3 0 1.6-1.4 3-3 3v5Z" }));
export default SvgTicket;
